import React, { useEffect } from "react";
import { IoCloseOutline } from "react-icons/io5";
import styles from "./ConfirmModal.module.css";

// Shared shell for the Publish/Save confirmation popups — the two were
// near-identical copies of the same overlay+header+footer markup.
export default function ConfirmModal({
  title,
  subtitle,
  children,
  onCancel,
  onConfirm,
  confirmLabel = "Confirm",
  confirmClassName,
}) {
  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === "Escape") onCancel?.();
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [onCancel]);

  return (
    <div className={styles.overlay} onClick={onCancel}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <div>
            <h2>{title}</h2>
            {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
          </div>
          <button className={styles.closeBtn} onClick={onCancel}>
            <IoCloseOutline />
          </button>
        </div>

        {children && <div className={styles.body}>{children}</div>}

        <div className={styles.footer}>
          <button className={styles.cancelBtn} onClick={onCancel}>
            Cancel
          </button>
          <button className={confirmClassName} onClick={onConfirm}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
